/* Ficha de producto Clara Duarte: cabecera, galería, visor, variantes y entrega estimada. */
(function () {
  'use strict';
  var root = document.getElementById('sj-pdp');
  if (!root) return;

  /* ---------- Avisos rotativos y menú ---------- */
  var ann = root.querySelector('.sj-ann');
  if (ann) {
    var msgs = ann.querySelectorAll('span'), ai = 0, paused = false;
    ann.addEventListener('mouseenter', function () { paused = true; });
    ann.addEventListener('mouseleave', function () { paused = false; });
    if (msgs.length > 1 && !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      setInterval(function () { if (paused) return; msgs[ai].classList.remove('on'); ai = (ai + 1) % msgs.length; msgs[ai].classList.add('on'); }, 5000);
    }
  }
  var menu = root.querySelector('#sj-menu'), burger = root.querySelector('.sj-burger');
  function setMenu(o) {
    if (!menu || !burger) return;
    menu.classList.toggle('open', o); menu.setAttribute('aria-hidden', String(!o)); burger.setAttribute('aria-expanded', String(o));
    document.documentElement.style.overflow = o ? 'hidden' : '';
  }
  if (burger) burger.addEventListener('click', function () { setMenu(true); });
  if (menu) menu.addEventListener('click', function (e) { if (e.target.closest('[data-close]') || e.target.closest('a')) setMenu(false); });

  /* ---------- Precios ---------- */
  var fmt;
  try { fmt = new Intl.NumberFormat('es-ES', { style: 'currency', currency: root.getAttribute('data-currency') || 'EUR' }); }
  catch (e) { fmt = { format: function (n) { return n.toFixed(2).replace('.', ',') + ' €'; } }; }
  function money(c) { return fmt.format(c / 100); }
  root.querySelectorAll('[data-cents]').forEach(function (el) { el.textContent = money(+el.getAttribute('data-cents')); });

  /* ---------- Galería ---------- */
  var gal = root.querySelector('[data-gal]');
  var track = gal && gal.querySelector('[data-track]');
  var slides = track ? Array.prototype.slice.call(track.children) : [];
  var navBtns = gal ? gal.querySelectorAll('[data-go]') : [];
  var current = 0;
  function centerLeft(i) { var s = slides[i]; return s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2; }
  function go(i, smooth) {
    if (!track || !slides[i]) return;
    track.scrollTo({ left: centerLeft(i), behavior: smooth === false ? 'auto' : 'smooth' });
    mark(i);
  }
  function mark(i) {
    current = i;
    for (var k = 0; k < navBtns.length; k++) {
      var on = +navBtns[k].getAttribute('data-go') === i;
      navBtns[k].setAttribute('aria-current', on ? 'true' : 'false');
      if (on && navBtns[k].parentNode.classList.contains('sj-thumbs')) {
        var p = navBtns[k].parentNode, b = navBtns[k];
        if (b.offsetTop < p.scrollTop || b.offsetTop + b.offsetHeight > p.scrollTop + p.clientHeight) p.scrollTop = b.offsetTop - 10;
      }
    }
  }
  if (track && slides.length) {
    var tick = 0;
    track.addEventListener('scroll', function () {
      if (tick) return;
      tick = requestAnimationFrame(function () {
        tick = 0;
        var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bd = Infinity;
        for (var i = 0; i < slides.length; i++) {
          var c = slides[i].offsetLeft + slides[i].offsetWidth / 2, d = Math.abs(c - mid);
          if (d < bd) { bd = d; best = i; }
        }
        if (best !== current) mark(best);
      });
    }, { passive: true });
    for (var n = 0; n < navBtns.length; n++) navBtns[n].addEventListener('click', function () { go(+this.getAttribute('data-go')); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(Math.min(current + 1, slides.length - 1)); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(Math.max(current - 1, 0)); }
    });
    window.addEventListener('resize', function () { go(current, false); });
  }

  /* ---------- Visor a pantalla completa ---------- */
  var lb = root.querySelector('[data-lb]');
  if (lb && slides.length) {
    var lbImg = lb.querySelector('img'), lbCount = lb.querySelector('.sj-lb-c'), lbX = lb.querySelector('.sj-lb-x'), lbIdx = 0, lbBack = null;
    var zooms = slides.map(function (s) { return s.getAttribute('data-zoom'); });
    var alts = slides.map(function (s) { var im = s.querySelector('img'); return im ? im.alt : ''; });
    var showLb = function (i) {
      lbIdx = (i + zooms.length) % zooms.length;
      if (!zooms[lbIdx]) return;
      lbImg.src = zooms[lbIdx]; lbImg.alt = alts[lbIdx] || '';
      lbCount.textContent = (lbIdx + 1) + ' / ' + zooms.length;
    };
    var openLb = function (i) {
      if (!zooms[i]) return;
      lbBack = document.activeElement; showLb(i); lb.hidden = false;
      document.documentElement.style.overflow = 'hidden'; lbX.focus();
    };
    var closeLb = function () {
      lb.hidden = true; document.documentElement.style.overflow = '';
      go(lbIdx, false); if (lbBack && lbBack.focus) lbBack.focus();
    };
    var multi = zooms.length > 1;
    lb.querySelector('.sj-lb-p').hidden = !multi; lb.querySelector('.sj-lb-n').hidden = !multi;
    lb.addEventListener('click', function (e) {
      if (e.target.closest('.sj-lb-x')) closeLb();
      else if (e.target.closest('.sj-lb-p')) showLb(lbIdx - 1);
      else if (e.target.closest('.sj-lb-n')) showLb(lbIdx + 1);
    });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') closeLb();
      if (e.key === 'ArrowRight' && multi) showLb(lbIdx + 1);
      if (e.key === 'ArrowLeft' && multi) showLb(lbIdx - 1);
      if (e.key === 'Tab') { var f = Array.prototype.filter.call(lb.querySelectorAll('button'), function (b) { return !b.hidden; }); var a = f.indexOf(document.activeElement); e.preventDefault(); f[(a + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus(); }
    });
    var zbtn = root.querySelector('.sj-zoom');
    if (zbtn) zbtn.addEventListener('click', function () { openLb(current); });
    track.addEventListener('click', function (e) { var s = e.target.closest('.sj-gal-slide'); if (s && e.target.tagName === 'IMG') openLb(slides.indexOf(s)); });
  }

  /* ---------- Entrega estimada (días laborables según data-min y data-max; fechas en negrita) ---------- */
  var eta = root.querySelector('[data-eta]');
  if (eta) {
    var dmin = +eta.getAttribute('data-min') || 0, dmax = +eta.getAttribute('data-max') || 0;
    var addBiz = function (d, k) { var x = new Date(d.getTime()); while (k > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) k--; } return x; };
    if (dmin && dmax) {
      try {
        var df = new Intl.DateTimeFormat('es-ES', { weekday: 'short', day: 'numeric', month: 'short' });
        var now = new Date();
        eta.innerHTML = 'Recíbelo entre el <b>' + df.format(addBiz(now, dmin)) + '</b> y el <b>' + df.format(addBiz(now, dmax)) + '</b>';
      } catch (e) {}
    }
  }

  /* ---------- Variantes ---------- */
  var dataEl = document.getElementById('sj-pdp-data');
  if (!dataEl) return;
  var P;
  try { P = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var form = root.querySelector('#sj-buy-form');
  if (!form) return;
  var idIn = form.querySelector('[name="id"]'), btn = form.querySelector('.sj-add'), soldMsg = form.querySelector('.sj-sold');
  var priceBox = root.querySelector('.sj-buy > .sj-price');
  var vbtns = Array.prototype.slice.call(root.querySelectorAll('.sj-val'));
  var nOpt = P.options.length;
  var first = P.variants.filter(function (v) { return String(v.id) === idIn.value; })[0] || P.variants[0];
  var sel = first ? first.options.slice() : [];
  var mediaOf = {};
  try { mediaOf = JSON.parse(document.getElementById('sj-vmedia').textContent); } catch (e) {
    P.variants.forEach(function (v) { if (v.featured_media && v.featured_media.id) mediaOf[v.id] = String(v.featured_media.id); });
  }

  function find() { return P.variants.filter(function (v) { return v.options.every(function (o, k) { return sel[k] === o; }); })[0]; }
  function avail(k, val) {
    return P.variants.some(function (v) {
      if (v.options[k] !== val || !v.available) return false;
      for (var j = 0; j < k; j++) if (v.options[j] !== sel[j]) return false;
      return true;
    });
  }
  function priceHTML(v) {
    var save = v.compare_at_price > v.price ? v.compare_at_price - v.price : 0;
    return '<strong>' + money(v.price) + '</strong>' + (save ? '<s>' + money(v.compare_at_price) + '</s><span class="sj-pill">Ahorras ' + money(save) + '</span>' : '');
  }
  function refresh(fromUser) {
    vbtns.forEach(function (b) {
      var k = +b.getAttribute('data-k'), val = b.getAttribute('data-v');
      b.setAttribute('aria-pressed', sel[k] === val ? 'true' : 'false');
      b.classList.toggle('sj-out', !avail(k, val));
    });
    root.querySelectorAll('[data-sel]').forEach(function (s) { s.textContent = sel[+s.getAttribute('data-sel')] || ''; });
    var v = find();
    if (v) {
      idIn.value = v.id;
      if (priceBox) priceBox.innerHTML = priceHTML(v);
      if (fromUser && window.history && history.replaceState) {
        var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString());
      }
      if (fromUser && mediaOf[v.id]) {
        for (var i = 0; i < slides.length; i++) if (slides[i].getAttribute('data-media-id') === mediaOf[v.id]) { go(i); break; }
      }
    }
    var ok = !!(v && v.available);
    btn.disabled = !ok;
    btn.textContent = !v ? 'No disponible' : (ok ? 'Añadir a la cesta' : 'Agotado');
    if (soldMsg) soldMsg.hidden = !(v && !v.available);
  }
  vbtns.forEach(function (b) {
    b.addEventListener('click', function () {
      var k = +b.getAttribute('data-k');
      sel[k] = b.getAttribute('data-v');
      // Si la combinación no existe, completa con la primera variante disponible que respete lo elegido hasta aquí.
      if (!find() || !find().available) {
        var alt = P.variants.filter(function (v) { if (!v.available) return false; for (var j = 0; j <= k; j++) if (v.options[j] !== sel[j]) return false; return true; })[0];
        if (alt) sel = alt.options.slice();
      }
      refresh(true);
    });
  });
  form.addEventListener('submit', function (e) { if (btn.disabled) e.preventDefault(); });
  form.addEventListener('sj:added', function () { refresh(false); });
  if (nOpt) refresh(false);
})();
